/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  IntermediateReportInterface,
  LearnosityItemsConfigInterface,
  LearnosityItemsSettingsInterface,
} from '../../+external-interfaces';
import { ContextInterface } from '../../+models';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class LearnosityApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'Learnosity');
  }

  previewActivity(learnosityReference: string): Observable<LearnosityItemsConfigInterface> {
    const path = `items/preview/${learnosityReference}`;
    return this.get<LearnosityItemsConfigInterface>(path, undefined);
  }

  buildItemsRequest(
    eduContentId: number,
    learnosityReference: string,
    sessionId: string,
    itemReferences?: string[],
    settings?: LearnosityItemsSettingsInterface,
    context?: ContextInterface
  ): Observable<LearnosityItemsConfigInterface> {
    const path = `items/request/${eduContentId}/reference/${learnosityReference}/session/${sessionId}`;
    const params = this._getHttpParams({ settings, context, itemReferences });
    return this.get<LearnosityItemsConfigInterface>(path, params);
  }

  buildLocalItemsRequest(
    eduContentId: number,
    learnosityReference: string,
    itemReferences?: string[],
    settings?: LearnosityItemsSettingsInterface
  ): Observable<LearnosityItemsConfigInterface> {
    const path = `items/request/${eduContentId}/reference/${learnosityReference}`;
    const params = this._getHttpParams({ settings, itemReferences });
    return this.get<LearnosityItemsConfigInterface>(path, params);
  }

  getIntermediateReport(
    sessionId: string,
    userId: string,
    activityId: string
  ): Observable<IntermediateReportInterface> {
    const path = `reports/intermediate/${sessionId}`;
    const params = this._getHttpParams({ userId, activityId });
    return this.get<IntermediateReportInterface>(path, params);
  }

  buildGradingRequest(studentId?: number): Observable<LearnosityItemsConfigInterface> {
    const path = `grading`;
    const params = this._getHttpParams({ studentId });
    return this.get<LearnosityItemsConfigInterface>(path, params);
  }

  buildReportsRequest(id: number): Observable<LearnosityItemsConfigInterface> {
    const path = `reports/${id}`;
    const params = undefined;
    return this.get<LearnosityItemsConfigInterface>(path, params);
  }

  exerciseStarted(
    sessionId: string,
    userId: string,
    activityId: string,
    eduContentId: number,
    registrationId: number
  ): Observable<any> {
    const path = `exercise/${sessionId}/started`;
    const body = {
      userId,
      activityId,
      eduContentId,
      registrationId,
    };

    return this.post(path, undefined, body);
  }

  exerciseCompleted(
    sessionId: string,
    userId: string,
    activityId: string,
    eduContentId: number,
    registrationId: number
  ): Observable<any> {
    const path = `exercise/${sessionId}/completed`;
    const body = {
      userId,
      activityId,
      eduContentId,
      registrationId,
    };

    return this.post(path, undefined, body);
  }

  exerciseDiscarded(
    sessionId: string,
    userId: string,
    activityId: string,
    eduContentId: number,
    registrationId: number
  ): Observable<any> {
    const path = `exercise/${sessionId}/discarded`;
    const body = {
      userId,
      activityId,
      eduContentId,
      registrationId,
    };

    return this.post(path, undefined, body);
  }

  itemAnswered(
    sessionId: string,
    userId: string,
    activityId: string,
    eduContentId: number,
    registrationId: number,
    itemReference?: string
  ): Observable<any> {
    const path = `exercise/${sessionId}/item/${itemReference}/answered`;
    const body = {
      userId,
      activityId,
      eduContentId,
      registrationId,
    };

    return this.post(path, undefined, body);
  }
}
